import { useStorage } from '@vueuse/core'

const state = useStorage('codecourse_player', {
    speed: 1,
    autoplay: true,
    quality: '1080p',
    volume: 1,
    muted: false,
    textTrack: null,
    transcript: true,
})

export default () => {
    return {
        state
    }
}
